import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbImpedimento extends AppService {
  abstract getImpedimentosByFilter(filter: AppFilter): Observable<any>;
  abstract getImpedimentosEFeriadosByAreaComumIdEEntreDatas(filter: AppFilter): Observable<any>;
}